module.exports = __webpack_public_path__ + "static/media/user-shield.c83b04c8.svg";